// Gallery images with tag-based filtering
export const GALLERY_IMAGES = [
  // Interior Design Images (8 images)
  {
    id: 1,
    src: "https://res.cloudinary.com/dknsjvavr/image/upload/v1753256357/c41aaba8-1106-45ea-8d06-e82ea8277f89_cbkmyz.jpg",
    alt: "Stylish elevator with reflective vertical striped panels and a decorative patterned floor design.",
    caption:
      "Elegant elevator interior featuring etched vertical mirror panels, spotlight ceiling lighting, and a circular floral floor pattern.",
    tags: ["interior", "design", "lighting", "walls", "ceiling"],
    category: "Interior Design",
  },
  {
    id: 2,
    src: "https://res.cloudinary.com/dknsjvavr/image/upload/v1753256356/ce657fa6-9e90-4808-a311-1758eb4d6b0e_hqhojy.jpg",
    alt: "Golden framed elevator entrance with reflective surfaces and a modern glass-paneled door.",
    caption:
      "Elegant elevator entrance with glass center doors, golden framing, and wooden flooring inside the cabin.",
    tags: ["interior", "doors", "design", "entrance", "walls"],
    category: "Door Systems",
  },
  {
    id: 3,
    src: "https://res.cloudinary.com/dknsjvavr/image/upload/v1753256355/c708ee05-a1aa-4c56-9b86-817d85523f1a_lthehs.jpg",
    alt: "Luxurious elevator cabin with wooden flooring, golden reflective walls, and a decorative ceiling light.",
    caption:
      "Modern elevator interior featuring warm wooden flooring, golden panel walls, and a circular patterned ceiling light.",
    tags: ["interior", "ceiling", "lighting", "design", "walls"],
    category: "Interior Design",
  },
  {
    id: 4,
    src: "https://res.cloudinary.com/dknsjvavr/image/upload/v1753256354/e19725d9-7a00-456e-8f3a-4a0af93083ca_oswcza.jpg",
    alt: "Interior view of a modern elevator with gold-toned walls and a decorative ceiling light fixture reflecting on the mirrored surface.",
    caption:
      "Luxurious elevator interior featuring a patterned ceiling light and golden reflective wall panels.",
    tags: ["interior", "ceiling", "lighting", "design", "walls"],
    category: "Interior Design",
  },
  {
    id: 5,
    src: "https://res.cloudinary.com/dknsjvavr/image/upload/v1753256347/8ad427af-0443-4e8b-a6af-55a4b8d20945_h1etcn.jpg",
    alt: "Interior corner of an elevator with brushed steel walls, a handrail, and wood-look flooring.",
    caption:
      "A detailed view of a modern elevator interior, showcasing the combination of brushed stainless steel walls, polished accent strips, a sturdy handrail, and warm wood-finish flooring.",
    tags: ["interior", "walls", "safety"],
    category: "Interior Design",
  },
  {
    id: 6,
    src: "https://res.cloudinary.com/dknsjvavr/image/upload/v1753256345/9ecbe436-5ae4-4ae1-b42a-bf977033236c_f3ykty.jpg",
    alt: "Ornate gold elevator doors with etched geometric patterns and backlit floral designs.",
    caption:
      "A stunning, fully-customized elevator entrance featuring gold-toned doors with an intricate geometric pattern and backlit floral motifs on the upper panel.",
    tags: ["doors", "design", "entrance", "lighting"],
    category: "Door Systems",
  },
  {
    id: 7,
    src: "https://res.cloudinary.com/dknsjvavr/image/upload/v1753256344/28e51d06-3177-41c4-b1b8-9cd79a4e3935_s2cvkf.jpg",
    alt: "Interior of a gold-toned elevator with a decorative ceiling light and wood-look floor.",
    caption:
      "A luxurious elevator interior featuring polished gold-toned wall panels, a wood-finish floor, and an elegant circular light fixture on the ceiling.",
    tags: ["interior", "design", "walls", "lighting"],
    category: "Interior Design",
  },
  {
    id: 8,
    src: "https://res.cloudinary.com/dknsjvavr/image/upload/v1753824963/WhatsApp_Image_2025-07-29_at_17.05.05_1_pdq2ls.jpg",
    alt: "Beautiful elevator interior showcasing ornate decorative ceiling design with sophisticated lighting and premium wall finishes.",
    caption:
      "Stunning newly installed elevator interior featuring an elaborate backlit ceiling with intricate decorative patterns. The premium stainless steel walls with protective film demonstrate the fresh installation of this luxury elevator design.",
    tags: ["interior", "ceiling", "design", "lighting", "installation"],
    category: "Interior Design",
  },

  // Door Systems Images (6 images)
  {
    id: 9,
    src: "https://res.cloudinary.com/dknsjvavr/image/upload/v1753256349/5e2a4f67-7bf3-4064-8398-ca40ee6f2614_ssbtqz.jpg",
    alt: "Elevator with stainless steel doors featuring large glass windows.",
    caption:
      "A modern elevator entrance with brushed stainless steel doors, each with large glass panels offering a view into the car's interior. The lift is set within a dark marble wall.",
    tags: ["doors", "entrance", "design"],
    category: "Door Systems",
  },
  {
    id: 10,
    src: "https://res.cloudinary.com/dknsjvavr/image/upload/v1753256347/8d583585-5de0-4071-ab39-700c0ce6cf56_i0aunv.jpg",
    alt: "An open glass elevator with a gold frame, wood floor, and visible control panel.",
    caption:
      "A luxurious glass and gold-toned elevator with doors open, revealing a wood-finish floor and an integrated control panel. The design is seamlessly integrated into a high-end interior space.",
    tags: ["doors", "entrance", "controls", "navigation"],
    category: "Door Systems",
  },
  {
    id: 11,
    src: "https://res.cloudinary.com/dknsjvavr/image/upload/v1753256343/40c8fc99-b002-4117-9a8b-e0b7b75c22e0_qhisdp.jpg",
    alt: "A closed elevator door with reflective glass panels and a gold-colored frame.",
    caption:
      "An elegant elevator entrance featuring sleek, dark-tinted glass doors and a polished gold-finish frame, set against a tiled wall.",
    tags: ["doors", "entrance", "design"],
    category: "Door Systems",
  },
  {
    id: 12,
    src: "https://res.cloudinary.com/dknsjvavr/image/upload/v1753256340/5062a85f-f33b-4d5a-8c3c-05804577980d_cy2o6r.jpg",
    alt: "An open elevator entrance showing the white interior and handrails.",
    caption:
      "A clean and modern elevator interior featuring bright lighting, white panel walls, and multiple handrails, viewed from the landing.",
    tags: ["doors", "entrance", "installation", "interior", "safety"],
    category: "Door Systems",
  },
  {
    id: 13,
    src: "https://res.cloudinary.com/dknsjvavr/image/upload/v1753256337/be7fd563-c9f2-430c-97c8-761f7c808630_clnbay.jpg",
    alt: "Modern reflective elevator doors with a bronze finish and glass center panels.",
    caption:
      "Sleek elevator door design with tinted glass inserts and a metallic bronze frame reflecting the surrounding environment.",
    tags: ["doors", "design", "entrance", "interior"],
    category: "Door Systems",
  },
  {
    id: 14,
    src: "https://res.cloudinary.com/dknsjvavr/image/upload/v1753256351/2d502609-aeee-4be2-a91d-2d041083c226_yvsxcf.jpg",
    alt: "Interior of a spacious, modern elevator with white walls, handrails, and bright lighting.",
    caption:
      "A view into a clean and functional elevator car, featuring bright LED spotlights, a ventilated ceiling, multiple handrails for support, and a durable floor.",
    tags: ["interior", "lighting", "ventilation", "safety"],
    category: "Interior Design",
  },

  // Control Systems Images (5 images)
  {
    id: 15,
    src: "https://res.cloudinary.com/dknsjvavr/image/upload/v1753256352/0c04381e-560e-4709-8519-c5298d7e0483_ea5k2u.jpg",
    alt: "A modern elevator control panel with a fingerprint scanner and backlit touch buttons.",
    caption:
      "A close-up of a sophisticated elevator control panel featuring a digital floor display, a biometric fingerprint scanner for security, and sleek, backlit touch buttons for floor selection and functions like alarm and ventilation.",
    tags: ["controls", "touchscreen", "navigation", "safety"],
    category: "Control Systems",
  },
  {
    id: 16,
    src: "https://res.cloudinary.com/dknsjvavr/image/upload/v1754392460/WhatsApp_Image_2025-07-30_at_16.07.32_1_nczwxx.jpg",
    alt: "Elevator control panels on display including Grand Neo Rose Gold and Black variants along with wiring and servo system below.",
    caption:
      "Showcase of Grand Neo elevator panels in rose gold and black finishes, alongside STEP Sirius Pro Edition servo integrated door drive.",
    tags: ["controls", "technology", "mechanical"],
    category: "Control Systems",
  },
  {
    id: 17,
    src: "https://res.cloudinary.com/dknsjvavr/image/upload/v1754392460/WhatsApp_Image_2025-07-30_at_16.07.33_1_ut0lny.jpg",
    alt: "Newly installed elevator interior with a geometric ceiling light and protective film on the walls.",
    caption:
      "The interior of a new elevator during installation, highlighting a striking backlit ceiling with a geometric star design and gold-toned walls partially covered in protective film.",
    tags: ["interior", "installation", "design", "lighting"],
    category: "Interior Design",
  },
  {
    id: 18,
    src: "https://res.cloudinary.com/dknsjvavr/image/upload/v1753256337/aa70b623-6962-4878-af4c-9896336cd3cd_fv3cl3.jpg",
    alt: "Manual wheelchair ramp lift platform by Dee Cee Elevators designed for accessibility in buildings.",
    caption:
      "Dee Cee Elevators' standard manual ramp lift ensures smooth wheelchair access across different floor levels.",
    tags: ["utilities", "mechanical", "safety", "installation"],
    category: "Safety & Utilities",
  },
  {
    id: 19,
    src: "https://res.cloudinary.com/dknsjvavr/image/upload/v1753256338/b7a02185-f93f-4949-bea9-9dc97ada8795_x0j2ey.jpg",
    alt: "Ceiling view of a modern elevator with bright LED square lighting and reflective surfaces.",
    caption:
      "Contemporary elevator interior featuring a geometric LED ceiling light, stainless steel walls, and illuminated control panel.",
    tags: ["interior", "ceiling", "lighting", "design", "controls"],
    category: "Ceiling & Overhead",
  },

  // Ceiling & Overhead Images (4 images)
  {
    id: 20,
    src: "https://res.cloudinary.com/dknsjvavr/image/upload/v1753256348/8c3ee88b-84f6-42fd-aa62-350478bd3e6c_lqrw93.jpg",
    alt: "Elevator ceiling with a backlit circular sunburst pattern and four spotlights.",
    caption:
      "An artistic view looking up at an elevator ceiling during installation, featuring a brightly lit central panel with a circular sunburst design, complemented by four corner spotlights.",
    tags: ["ceiling", "lighting", "design", "installation"],
    category: "Ceiling & Overhead",
  },
  {
    id: 21,
    src: "https://res.cloudinary.com/dknsjvavr/image/upload/v1753256352/00c7c497-4257-4cc2-ac98-0d7918e3965a_gfovv1.jpg",
    alt: "Elevator ceiling with a backlit floral mandala light panel and four spotlights.",
    caption:
      "A beautifully illuminated elevator ceiling, featuring a central backlit panel with an intricate floral mandala design, complemented by four bright spotlights in the corners.",
    tags: ["ceiling", "lighting", "design"],
    category: "Ceiling & Overhead",
  },
  {
    id: 22,
    src: "https://res.cloudinary.com/dknsjvavr/image/upload/v1753256344/38d2c9a1-bdf8-4ebc-a13a-74603a2e869a_gpglwb.jpg",
    alt: "Elevator ceiling with a backlit geometric star pattern light fixture.",
    caption:
      "A stunning view looking up at an elevator ceiling, featuring a backlit panel with an intricate geometric star design, surrounded by reflective gold-toned surfaces.",
    tags: ["ceiling", "lighting", "design"],
    category: "Ceiling & Overhead",
  },
  {
    id: 23,
    src: "https://res.cloudinary.com/dknsjvavr/image/upload/v1753256339/5147afa2-56e6-4a4f-bdc9-85475778726b_mootgt.jpg",
    alt: "Elevator ceiling with a floral-patterned light and four spotlights.",
    caption:
      "A beautifully designed elevator ceiling featuring an elegant floral light fixture, complemented by modern spotlights and a reflective finish.",
    tags: ["ceiling", "lighting", "design"],
    category: "Ceiling & Overhead",
  },

  // Design & Materials Images (4 images)
  {
    id: 24,
    src: "https://res.cloudinary.com/dknsjvavr/image/upload/v1753824903/WhatsApp_Image_2025-07-29_at_17.04.44_3_ceiltr.jpg",
    alt: "Elevator material finish samples and design options showcasing various textures and finishes for interior customization.",
    caption:
      "Collection of premium material finish samples and design swatches for elevator interior customization, featuring various textures, colors, and surface treatments.",
    tags: ["design", "materials", "finishes", "interior", "customization"],
    category: "Design & Materials",
  },
  {
    id: 25,
    src: "https://res.cloudinary.com/dknsjvavr/image/upload/v1753256341/998c63a4-f01d-4b86-9ac2-d2ea23361d84_d11q8y.jpg",
    alt: "Decorative tile design with a central mandala and Greek key border.",
    caption:
      "A detailed view of a decorative panel design, featuring an intricate floral mandala at the center, framed by a classic Greek key pattern on a marble-textured background.",
    tags: ["design", "walls", "materials"],
    category: "Design & Materials",
  },
  {
    id: 26,
    src: "https://res.cloudinary.com/dknsjvavr/image/upload/v1753824910/WhatsApp_Image_2025-07-29_at_17.05.04_3_vobcsi.jpg",
    alt: "Three-side glass cubical elevator with transparent panels offering panoramic views and modern architectural design.",
    caption:
      "Innovative three-side glass cubical elevator featuring transparent glass panels on three sides, providing unobstructed panoramic views and seamless integration with modern architecture.",
    tags: ["interior", "doors", "design", "glass", "panoramic"],
    category: "Door Systems",
  },
  {
    id: 27,
    src: "https://res.cloudinary.com/dknsjvavr/image/upload/v1753824905/WhatsApp_Image_2025-07-29_at_17.04.41_xek5ir.jpg",
    alt: "Premium elevator with luxurious gold finish door panels set against elegant dark marble walls in modern interior.",
    caption:
      "Premium elevator featuring stunning gold finish door panels, showcasing luxury craftsmanship and elegant integration with sophisticated marble surroundings.",
    tags: ["doors", "entrance", "design", "luxury", "premium"],
    category: "Door Systems",
  },

  // Installation & Construction Images (3 images)
  {
    id: 28,
    src: "https://res.cloudinary.com/dknsjvavr/image/upload/v1753824901/WhatsApp_Image_2025-07-29_at_17.04.42_1_f29mrj.jpg",
    alt: "Premium elevator interior design with reflective walls and sophisticated lighting during installation phase.",
    caption:
      "Premium elevator interior featuring reflective wall panels and sophisticated design elements during installation phase. The modern hall call button and marble-finished landing showcase luxury architectural integration.",
    tags: ["interior", "design", "installation", "luxury", "walls"],
    category: "Interior Design",
  },
  {
    id: 29,
    src: "https://res.cloudinary.com/dknsjvavr/image/upload/v1753824905/WhatsApp_Image_2025-07-29_at_17.04.45_1_rfsd1t.jpg",
    alt: "Beautiful custom stone floor design in elevator with decorative patterns and sophisticated lighting during installation.",
    caption:
      "Stunning elevator featuring a beautiful custom stone floor with intricate decorative patterns and sophisticated lighting design during installation phase. The elegant stone flooring treatment showcases premium craftsmanship and attention to detail.",
    tags: ["design", "flooring", "stone", "installation", "luxury"],
    category: "Design & Materials",
  },
  {
    id: 30,
    src: "https://res.cloudinary.com/dknsjvavr/image/upload/v1753256349/5b2d22b0-cff3-4738-8849-ef8ffdf11e19_qeeell.jpg",
    alt: "Open elevator showing a decorative etched back wall, floor inlay, and a digital call button.",
    caption:
      "An elegant elevator car with doors open, revealing a beautifully etched decorative panel on the rear wall and a patterned floor inlay. The polished steel interior and a modern digital call button complete the sophisticated look.",
    tags: ["entrance", "navigation", "design", "controls"],
    category: "Control Systems",
  },

];

export const GALLERY_VIDEOS = [
  {
    id: 31,
    src: "https://res.cloudinary.com/dknsjvavr/video/upload/v1753825347/WhatsApp_Video_2025-07-29_at_17.05.06_1_qrij1q.mp4",
    thumbnail:
      "https://res.cloudinary.com/dknsjvavr/video/upload/v1753825347/WhatsApp_Video_2025-07-29_at_17.05.06_1_qrij1q.jpg",
    alt: "Luxury elevator interior showcase",
    caption:
      "Virtual tour showcasing our premium elevator interior featuring elegant design, lighting, and premium finishes.",
    type: "video",
    category: "Videos",
    isLatest: true,
    featured: true,
  },
  {
    id: 32,
    src: "https://res.cloudinary.com/dknsjvavr/video/upload/v1753825346/WhatsApp_Video_2025-07-29_at_17.05.00_me6tvm.mp4",
    thumbnail:
      "https://res.cloudinary.com/dknsjvavr/video/upload/v1753825346/WhatsApp_Video_2025-07-29_at_17.05.00_me6tvm.jpg",
    alt: "Open elevator for low-rise buildings",
    caption:
      "Demonstration of our open elevator system designed for low-rise buildings with 1-2 floors, offering easy access and installation.",
    type: "video",
    category: "Videos",
  },
  {
    id: 33,
    src: "https://res.cloudinary.com/dknsjvavr/video/upload/v1753825344/WhatsApp_Video_2025-07-29_at_17.04.41_bti5l9.mp4",
    thumbnail:
      "https://res.cloudinary.com/dknsjvavr/video/upload/v1753825344/WhatsApp_Video_2025-07-29_at_17.04.41_bti5l9.jpg",
    alt: "Premium elevator interior showcase",
    caption:
      "Showcase of our luxury elevator interior highlighting premium materials, sophisticated lighting, and elegant design details.",
    type: "video",
    category: "Videos",
  },
  {
    id: 34,
    src: "https://res.cloudinary.com/dknsjvavr/video/upload/v1753825343/WhatsApp_Video_2025-07-29_at_17.04.48_n0xseg.mp4",
    thumbnail:
      "https://res.cloudinary.com/dknsjvavr/video/upload/v1753825343/WhatsApp_Video_2025-07-29_at_17.04.48_n0xseg.jpg",
    alt: "Elevator showcase at Udaypur City Palace",
    caption:
      "Showcase of our premium elevator installation at the prestigious Udaypur City Palace, featuring luxury finishes and elegant design.",
    type: "video",
    category: "Videos",
  },
  {
    id: 35,
    src: "https://res.cloudinary.com/dknsjvavr/video/upload/v1753825341/WhatsApp_Video_2025-07-29_at_17.05.06_pldaki.mp4",
    thumbnail:
      "https://res.cloudinary.com/dknsjvavr/video/upload/v1753825341/WhatsApp_Video_2025-07-29_at_17.05.06_pldaki.jpg",
    alt: "Cross elevator system demonstration",
    caption:
      "Demonstration of our innovative cross elevator system featuring multi-directional movement capabilities and advanced engineering.",
    type: "video",
    category: "Videos",
  },
  {
    id: 36,
    src: "https://res.cloudinary.com/dknsjvavr/video/upload/v1753825340/WhatsApp_Video_2025-07-29_at_17.05.03_s30ont.mp4",
    thumbnail:
      "https://res.cloudinary.com/dknsjvavr/video/upload/v1753825340/WhatsApp_Video_2025-07-29_at_17.05.03_s30ont.jpg",
    alt: "Glass elevator with panoramic view",
    caption:
      "Demonstration of our glass elevator featuring transparent panels on three sides, offering panoramic views and modern design.",
    type: "video",
    category: "Videos",
  },
  {
    id: 37,
    src: "https://res.cloudinary.com/dknsjvavr/video/upload/v1753825338/WhatsApp_Video_2025-07-29_at_17.04.43_sdzgdd.mp4",
    thumbnail:
      "https://res.cloudinary.com/dknsjvavr/video/upload/v1753825338/WhatsApp_Video_2025-07-29_at_17.04.43_sdzgdd.jpg",
    alt: "Premium glass door elevator showcase",
    caption:
      "Showcase of our premium elevator featuring elegant glass doors, luxury interior design, and sophisticated architectural integration.",
    type: "video",
    category: "Videos",
  },
  {
    id: 38,
    src: "https://res.cloudinary.com/dknsjvavr/video/upload/v1754391792/WhatsApp_Video_2025-07-29_at_17.04.46_o0ewhc.mp4",
    thumbnail:
      "https://res.cloudinary.com/dknsjvavr/video/upload/v1754391792/WhatsApp_Video_2025-07-29_at_17.04.46_o0ewhc.jpg",
    type: "video",
    category: "Videos",
  },
  {
    id: 39,
    src: "https://res.cloudinary.com/dknsjvavr/video/upload/v1753825346/WhatsApp_Video_2025-07-29_at_17.04.57_d0hcij.mp4",
    thumbnail:
      "https://res.cloudinary.com/dknsjvavr/video/upload/v1753825346/WhatsApp_Video_2025-07-29_at_17.04.57_d0hcij.jpg",
    type: "video",
    category: "Videos",
  },
  {
    id: 40,
    src: "https://res.cloudinary.com/dknsjvavr/video/upload/v1753825340/WhatsApp_Video_2025-07-29_at_17.04.54_ne2ugf.mp4",
    thumbnail:
      "https://res.cloudinary.com/dknsjvavr/video/upload/v1753825340/WhatsApp_Video_2025-07-29_at_17.04.54_ne2ugf.jpg",
    type: "video",
    category: "Videos",
  },
  {
    id: 41,
    src: "https://res.cloudinary.com/dknsjvavr/video/upload/v1753825339/WhatsApp_Video_2025-07-29_at_17.04.51_c8bnyh.mp4",
    thumbnail:
      "https://res.cloudinary.com/dknsjvavr/video/upload/v1753825339/WhatsApp_Video_2025-07-29_at_17.04.51_c8bnyh.jpg",
    type: "video",
    category: "Videos",
  },
  {
    id: 42,
    src: "https://res.cloudinary.com/dknsjvavr/video/upload/v1753825338/WhatsApp_Video_2025-07-29_at_17.04.38_obvyue.mp4",
    thumbnail:
      "https://res.cloudinary.com/dknsjvavr/video/upload/v1753825338/WhatsApp_Video_2025-07-29_at_17.04.38_obvyue.jpg",
    type: "video",
    category: "Videos",
  },
  {
    id: 43,
    src: "https://res.cloudinary.com/dknsjvavr/video/upload/v1754392462/WhatsApp_Video_2025-07-30_at_16.07.34_kpjgiv.mp4",
    thumbnail:
      "https://res.cloudinary.com/dknsjvavr/video/upload/v1754392462/WhatsApp_Video_2025-07-30_at_16.07.34_kpjgiv.jpg",
    type: "video",
    category: "Videos",
  },
];

// Updated Filter tags configuration based on actual usage
export const FILTER_TAGS = [
  { id: "all", name: "All Features", icon: "th", color: "#0062cc" },
  { id: "interior", name: "Interiors", icon: "home", color: "#2196f3" },
  { id: "doors", name: "Doors", icon: "door-open", color: "#1976d2" },
  { id: "controls", name: "Controls", icon: "sliders-h", color: "#0277bd" },
  { id: "ceiling", name: "Ceiling", icon: "crown", color: "#0288d1" },
  { id: "design", name: "Design", icon: "palette", color: "#03a9f4" },
  { id: "videos", name: "Videos", icon: "play-circle", color: "#e91e63" },
];

export function getDescriptionForTag(tagId) {
  const descriptions = {
    all: "Complete collection of our elevator features and installations",
    interior: "Elegant cabin interiors, wall panels, and design elements",
    doors: "Advanced door mechanisms and entrance solutions",
    controls: "Modern navigation panels and smart control interfaces",
    ceiling: "Innovative ceiling designs and overhead installations",
    videos: "Video demonstrations and client testimonials",
  };
  return descriptions[tagId] || "Elevator features and components";
}

export const ELEVATOR_CATEGORIES = FILTER_TAGS.map((tag) => ({
  id: tag.id,
  name: tag.name,
  description: getDescriptionForTag(tag.id),
  images:
    tag.id === "all"
      ? [...GALLERY_IMAGES, ...GALLERY_VIDEOS]
      : tag.id === "videos"
      ? GALLERY_VIDEOS
      : GALLERY_IMAGES.filter((img) => img.tags.includes(tag.id)),
  color: tag.color,
}));

// Gallery statistics
export const GALLERY_STATS = {
  totalImages: GALLERY_IMAGES.length,
  totalVideos: GALLERY_VIDEOS.length,
  totalMedia: GALLERY_IMAGES.length + GALLERY_VIDEOS.length,
  totalCategories: FILTER_TAGS.length - 1, // Excluding "all"
  imagesByCategory: {
    interior: GALLERY_IMAGES.filter((img) => img.tags.includes("interior"))
      .length,
    doors: GALLERY_IMAGES.filter((img) => img.tags.includes("doors")).length,
    controls: GALLERY_IMAGES.filter((img) => img.tags.includes("controls"))
      .length,
    ceiling: GALLERY_IMAGES.filter((img) => img.tags.includes("ceiling"))
      .length,
    lighting: GALLERY_IMAGES.filter((img) => img.tags.includes("lighting"))
      .length,
    design: GALLERY_IMAGES.filter((img) => img.tags.includes("design")).length,
    installation: GALLERY_IMAGES.filter((img) =>
      img.tags.includes("installation")
    ).length,
    safety: GALLERY_IMAGES.filter((img) => img.tags.includes("safety")).length,
    videos: GALLERY_VIDEOS.length,
  },
};

// Helper function to get the latest installation
export const getLatestInstallation = () => {
  const allMedia = [...GALLERY_IMAGES, ...GALLERY_VIDEOS];
  return allMedia.find(item => item.isLatest) || allMedia[0];
};

// Helper function to sort gallery items with latest first
export const getSortedGalleryItems = (items) => {
  return [...items].sort((a, b) => {
    // Latest installation comes first
    if (a.isLatest && !b.isLatest) return -1;
    if (!a.isLatest && b.isLatest) return 1;
    // Featured items come next
    if (a.featured && !b.featured) return -1;
    if (!a.featured && b.featured) return 1;
    // Then sort by ID (newest first)
    return b.id - a.id;
  });
};
